import { Injectable } from '@angular/core';

import { SystemButtonDataEntryDto } from '@osos/shared/api';
import { SystemButtonDataPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable({
  providedIn: 'root',
})
export class SystemButtonParserV1Service extends ParserBase<
  SystemButtonDataEntryDto,
  SystemButtonDataPresenterModel
> {
  constructor() {
    super(SystemButtonDataEntryDto, SystemButtonDataPresenterModel, 1);
  }
  getPresenterModel(
    model: Partial<SystemButtonDataEntryDto>,
  ): SystemButtonDataPresenterModel {
    return {
      id: model.id,
      dataEntity: model.dataEntity,
      specificationVersion: this.version,
      state: model.state,
      actionTypes: model.value?.actionTypes,
      isPublished: model.value?.isPublished,
      relatedTo: model.value?.relatedTo,
      relevantAction: model.value?.relevantAction,
      icon: model.value?.icon,
      name: model.value?.name,
      description: model.value?.description,
      query: model.value?.query,
      criteria: model.value?.criteria,
      nonMatchEntriesMode: model.value?.nonMatchEntriesMode,
    };
  }
  getDataModel(presenter: SystemButtonDataPresenterModel): any {
    const model = {
      specificationVersion: this.version,
      // dataEntity: presenter.dataEntity,
      // state: presenter.state,
      // isInvalid: false,
      value: {
        actionTypes: presenter.actionTypes,
        icon: presenter.icon,
        name: presenter.name,
        relatedTo: presenter.relatedTo,
        relevantAction: {
          type: presenter.relevantAction.type,
          triggerId: presenter.relevantAction.triggerId,
          redirection: presenter.relevantAction.redirection,
          successRedirection: presenter.relevantAction.successRedirection,
          failureRedirection: presenter.relevantAction.failureRedirection,
          fieldsMapping: presenter.relevantAction.fieldsMapping,
          overrideFieldsMappingLockedFields:
            presenter.relevantAction.overrideFieldsMappingLockedFields,
        },
        description: presenter.description,
        isPublished: presenter.isPublished,
        query: presenter.query,
        criteria: presenter.criteria,
        nonMatchEntriesMode: presenter.nonMatchEntriesMode,
      },
    };

    return model;
  }
}
